module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc"
    }
  }, [_c('p', {
    staticClass: "FM-Epigraph-non-verse-fmepi"
  }, [_c('span', {
    attrs: {
      "aria-label": "ix",
      "id": "pg_ix",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("“You cannot save the land apart from the people, or the people apart from the land.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "FM-Epigraph-Source-fmeps"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("—WENDELL BERRY")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21679962","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 75
// module chunks = 0